import { dataDetailList } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDetailList = /*#__PURE__*/createIcon(dataDetailList)
export default IconDetailList
